import React from 'react';
import ReactDOM from 'react-dom';
import {
	ModalBody,
	ModalClose,
	ModalInner,
	ModalWrapper,
	ModalContainer,
	ModalBackground,
} from './modal.style';

export default function Modal({ open, onClose, children, maxWidth }) {
	const onCloseRef = React.useRef(onClose);
	React.useMemo(() => {
		onCloseRef.current = onClose;
	}, [onClose]);

	const [root, setRoot] = React.useState(null);

	React.useEffect(() => {
		setRoot(document.querySelector('#root-modal'));
	}, []);

	React.useEffect(() => {
		function onKeyDown(event) {
			if (event.key === 'Escape') {
				onCloseRef.current();
			}
		}

		window.addEventListener('keydown', onKeyDown);
		return () => {
			window.removeEventListener('keydown', onKeyDown);
		};
	}, []);

	if (root === null) return null;

	return ReactDOM.createPortal(
		<ModalWrapper className={open ? 'open' : 'closed'}>
			<ModalBackground onClick={onClose} />
			<ModalContainer>
				<ModalInner style={{ maxWidth }}>
					<ModalClose onClick={onClose}>
						<span>&times;</span>
					</ModalClose>
					<ModalBody>{children}</ModalBody>
				</ModalInner>
			</ModalContainer>
		</ModalWrapper>,
		root
	);
}
